<template lang="pug">
  .contentpage
    .header-area(v-if="areas.header && areas.header.length")
      //- section(v-for="(section, index) in areas.header" :key="section.id" :class="section.key" v-if="index === 0")
      //-   Banner(v-if="section.key === 'banner'" :section="section")
      //-   Slider(v-if="section.key === 'slider'" :section="section")
    .main-area(v-if="areas.main && areas.main.length")
      template(v-for="(section, index) in areas.main" v-if="isAllowed(section.key, 'main')")
        Heading.container.mx-auto(v-if="section.key === 'heading'" :section="section")
        Post.container.mx-auto(v-if="section.key === 'post'" :section="section")
        CategoryPosts.container.mx-auto(v-if="section.key === 'categoryposts'" :section="section")
        ImageSection.container.mx-auto(v-if="section.key === 'image'" :section="section")
        PhotoAlbum.container.mx-auto(v-if="section.key === 'photoalbum'" :section="section")
        Slider.container.mx-auto(v-if="section.key === 'slider'" :section="section")
        LoginForm.container.mx-auto(v-if="section.key === 'login'" :section="section")
        ContactForm.container.mx-auto(v-if="section.key === 'form'" :section="section")
</template>

<script>
import Page from '@/views/Page';

import Heading from '@/sections/Heading';
import Slider from '@/sections/Slider';
import Post from '@/sections/Post';
import Banner from '@/sections/Banner';
import CategoryPosts from '@/sections/CategoryPosts';
import ImageSection from '@/sections/Image';
import PhotoAlbum from '@/sections/PhotoAlbum';
import ContactForm from '@/extensions/forms/sections/Form';

export default {
  name: 'ContentPage',
  extends: Page,
  components: {
    Heading,
    Slider,
    Post,
    Banner,
    CategoryPosts,
    ImageSection,
    PhotoAlbum,
    ContactForm
  },
  methods: {
    isAllowed(key, area = 'main') {
      switch (area) {
        // case 'header':
        //   return ['banner', 'slider'].includes(key);

        case 'main':
        default:
          return ['heading', 'post', 'categoryposts', 'image', 'photoalbum', 'slider', 'form'].includes(key);
      }
    }
  },
  mounted () {
    document.body.classList.add('base')
  },
  destroyed () {
    document.body.classList.remove('base')
  }
};
</script>

<style lang="sass" scoped>
section.slider,
section.banners
  padding: 0
section.heading
  padding-bottom: 0
</style>
